import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 768" {...props}>
      <path
        fill="currentColor"
        d="M54.628 178.746c-12.497-12.496-32.758-12.496-45.255 0s-12.496 32.758 0 45.255l374.625 374.626 374.63-374.626c12.496-12.496 12.496-32.758 0-45.255-12.5-12.496-32.759-12.496-45.258 0l-329.372 329.372-329.371-329.373z"
      ></path>
    </svg>
  );
}

export default Icon;
